import { AccountRole, UserRole } from '@common/types';
import { AppRoles } from '@common/types/general/general';

export const pickUserRole = <R extends AppRoles>(roles: R, currentRoles: Array<UserRole | AccountRole>) => {
  return roles.filter((role) => currentRoles?.some((currentRole) => currentRole === role));
};
